(function(){
  var root = (document.currentScript && document.currentScript.previousElementSibling) || document.querySelector('.aoam-fm--d');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');
  // sprite size in px at the render's 5.6836 px/mm, so mm = px / PPM (one camera, one scale)
  var PPM = 5.683573782444;
  var PX = {tubeL:[881,147],tubeR:[881,147],adapterF:[322,192],adapterU:[323,192],critterL:[818,183],critterR:[812,183],twist:[131,147],twistR:[131,147],hilt:[534,191],hilt2:[534,191],endcap:[119,175],conn:[230,191],capL:[304,245],capR:[308,245],mount:[314,157],weight:[285,114],capK:[302,244]};
  var LBL = {twist:'Twist-on cap',twistR:'Twist-on cap',capL:'Silicone Saber Cap, clear',capR:'Silicone Saber Cap, clear',tubeL:'Saber tube',tubeR:'Saber tube',adapterF:'Tube adapter',adapterU:'Tube adapter',critterL:'RGB Critter BT',critterR:'2nd RGB Critter BT',hilt:'Handle extension',hilt2:'2nd handle extension',endcap:'End cap',conn:'Critter Connector',mount:'Counterweight mount',weight:'Weight',capK:'Silicone Saber Cap, black'};
  // joints: t = twists on (our house TWIST IT ON mark: a 300 deg ring with a dart, as on the live How It Connects cards), p = pushes or slides on (chevrons).
  // The clear Silicone Saber Cap pushes on OVER the twist-on cap at a blade tip (Saber, Contact and Staff kit copy), so it hides the cap when built. o = mm of the male nose hidden when assembled
  var J = {
    'twist>tubeL':{t:'t',o:3},'tubeL>adapterF':{t:'p',o:0},'adapterF>critterL':{t:'t',o:7.7},'critterL>hilt':{t:'t',o:9.2},
    'hilt>endcap':{t:'t',o:8.2},'critterL>endcap':{t:'t',o:8.2},'hilt>hilt2':{t:'t',o:9.2},'hilt2>mount':{t:'t',o:5},
    'mount>weight':{t:'p',o:0},'weight>capK':{t:'p',o:10},'mount>capK':{t:'p',o:49.75},'capL>twist':{t:'p',o:24.05},'tubeR>twistR':{t:'t',o:3},'twistR>capR':{t:'p',o:24.05},'critterL>conn':{t:'t',o:9},
    'conn>critterR':{t:'t',o:9.2},'critterR>adapterU':{t:'t',o:7.7},'adapterU>tubeR':{t:'p',o:0},'tubeR>capR':{t:'p',o:4}
  };
  var B = {
    light:{chain:['critterL','endcap'],z:{critterL:5,endcap:3}},
    saber:{chain:['capL','twist','tubeL','adapterF','critterL','hilt','endcap'],z:{capL:3,twist:1,tubeL:2,adapterF:3,critterL:6,hilt:5,endcap:4}},
    contact:{chain:['capL','twist','tubeL','adapterF','critterL','hilt','hilt2','mount','weight','capK'],z:{capL:3,twist:1,tubeL:2,adapterF:3,critterL:7,hilt:6,hilt2:5,mount:4,weight:2,capK:5}},
    staff:{chain:['capL','twist','tubeL','adapterF','critterL','conn','critterR','adapterU','tubeR','twistR','capR'],z:{capL:3,twist:1,twistR:1,tubeL:2,adapterF:3,critterL:5,conn:4,critterR:5,adapterU:3,tubeR:2,capR:3}}
  };
  var ORDER = ['light','saber','contact','staff'];
  var GAP = 24; // mm between parts when exploded, wide enough that the twist ring sits in open space like the live cards
  var stage = root.querySelector('.fmd-stage'), svg = root.querySelector('.fmd-svg');
  var labels = root.querySelector('.fmd-labels'), badge = root.querySelector('.fmd-badge');
  var tog = root.querySelector('.fmd-tog'), scaleBar = root.querySelector('.fmd-scale i');
  var chips = [].slice.call(root.querySelectorAll('.fm-chip'));
  var el = {}; [].forEach.call(root.querySelectorAll('.fmd-p'), function(i){ el[i.getAttribute('data-k')] = i; });
  // glow layers: each lit part's own sprite as a mask, so the light follows its exact outline
  var GL = ['tubeL','tubeR','capL','capR'], gl = {}, beam = root.querySelector('.fmd-beam');
  var HUE = { light: '-6s', saber: '0s', contact: '-2s', staff: '-4s' };
  GL.forEach(function(k){
    var g = document.createElement('span'); g.className = /^cap/.test(k) ? 'fmd-g is-cap' : 'fmd-g';
    g.innerHTML = '<i></i>'; g.firstChild.style.setProperty('--m', 'url("' + el[k].getAttribute('src') + '")');
    if (k === 'capR') g.firstChild.style.setProperty('--core', '0%');
    el[k].parentNode.insertBefore(g, el[k].nextSibling); gl[k] = g;
  });
  // vent glow over each tube adapter (sprite-measured hole centres; adapterU is the mirror)
  var HL = { adapterF: '30.4%', adapterU: '69.6%' }, hl = {};
  Object.keys(HL).forEach(function(k){
    var h = document.createElement('span'); h.className = 'fmd-h'; h.innerHTML = '<i></i>';
    h.firstChild.style.setProperty('--hx', HL[k]); el[k].parentNode.insertBefore(h, el[k].nextSibling); hl[k] = h;
  });
  var cur = 'light', open = true, timers = [], auto = false, stopped = false, settleT = null;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NS = 'http://www.w3.org/2000/svg';
  function mm(k){ return { L: PX[k][0] / PPM, D: PX[k][1] / PPM }; }
  function vertical(){ return stage.clientWidth < 600; }

  // ONE scale for every build (set by the longest, the staff taken apart), so the Critter is the same
  // size in all four and only the parts around it come and go
  function exploded(bk){ var x = 0, ex = {}; B[bk].chain.forEach(function(k){ ex[k] = x; x += mm(k).L + GAP; }); return ex; }
  function spanOf(bk){ var ex = exploded(bk), ch = B[bk].chain, last = ch[ch.length - 1]; return ex[last] + mm(last).L; }
  var MAXLEN = 0; ORDER.forEach(function(bk){ MAXLEN = Math.max(MAXLEN, spanOf(bk)); });

  function layout(bk, isOpen){
    var b = B[bk], ch = b.chain, i, x, pos = {}, vert = vertical();
    var W = stage.clientWidth, H = stage.clientHeight;
    var run = vert ? H - 24 : W - 24;
    // desktop holds one scale for all four builds; a phone column is too short for that, so each
    // build fills it (the scale bar follows, and every part in a build still shares one scale)
    var s = vert ? Math.min(1.3, run / spanOf(bk)) : run / MAXLEN;
    // exploded: every part side by side with GAP between, centred on the stage
    var ex = exploded(bk), exLen = spanOf(bk);
    // assembled: each male nose hides inside its neighbour; the weight sits inside the mount
    var as = {}; x = 0;
    ch.forEach(function(k, n){
      var m = mm(k);
      if (k === 'weight') { as[k] = as.mount + mm('mount').L - m.L - 3; return; }
      as[k] = x;
      var nx = ch[n + 1]; if (nx === 'weight') nx = ch[n + 2];
      var j = nx ? J[k + '>' + nx] : null;
      x += m.L - (j ? j.o : 0);
    });
    // hold the Critter still: shift the assembled row so its centre matches the exploded one
    var shift = ex.critterL - as.critterL;
    var off = ((vert ? H : W) - exLen * s) / 2;
    // phone: the column sits left with labels beside it when apart, and moves to the middle when built
    var axis = vert ? (isOpen ? Math.round(W * 0.27) : Math.round(W / 2)) : 84;
    ch.forEach(function(k){
      var m = mm(k), left = isOpen ? ex[k] : as[k] + shift;
      var c = off + (left + m.L / 2) * s;
      pos[k] = { c: c, w: m.L * s, h: m.D * s, a: axis, left: left };
    });
    return { bk: bk, s: s, pos: pos, vert: vert, axis: axis, off: off, ex: ex, chain: ch, W: W, H: H };
  }

  function place(k, p, vert, z, node){
    var i = node || el[k];
    i.style.width = p.w + 'px'; i.style.height = p.h + 'px';
    var cx = vert ? p.a : p.c, cy = vert ? p.c : p.a;
    i.style.left = (cx - p.w / 2) + 'px'; i.style.top = (cy - p.h / 2) + 'px';
    i.style.transform = vert ? 'rotate(90deg)' : 'none';
    i.style.zIndex = z;
  }

  function overlays(L){
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    labels.innerHTML = '';
    var ch = L.chain, vert = L.vert;
    // joint marks in each gap
    for (var n = 0; n < ch.length - 1; n++) {
      var a = ch[n], b = ch[n + 1], j = J[a + '>' + b] || { t: 'p' };
      var pa = L.pos[a], pb = L.pos[b];
      var mid = (pa.c + pa.w / 2 + pb.c - pb.w / 2) / 2;
      var r = Math.max(9, Math.min(pa.h, pb.h) * 0.56);
      var g = document.createElementNS(NS, 'g');
      g.setAttribute('transform', vert ? 'translate(' + L.axis + ',' + mid + ') rotate(90)' : 'translate(' + mid + ',' + L.axis + ')');
      var path = document.createElementNS(NS, 'path');
      if (j.t === 't') {
        // house TWIST IT ON mark (build_exploded_views.py coil()): a 300 deg ellipse foreshortened to .36,
        // gap on the far side, ending at the top in a filled dart that points along the axis at the part it mates
        var dir = L.pos.critterL.c >= mid ? 1 : -1, rx = Math.max(3.5, r * 0.36), hd = Math.max(6, Math.min(10, r * 0.42));
        path.setAttribute('d', 'M ' + (dir * 0.866 * rx) + ' ' + (-0.5 * r) + ' A ' + rx + ' ' + r + ' 0 1 ' + (dir > 0 ? 1 : 0) + ' 0 ' + (-r));
        var head = document.createElementNS(NS, 'path');
        head.setAttribute('d', 'M ' + (dir * hd) + ' ' + (-r) + ' L ' + (-dir * 0.6) + ' ' + (-r - hd * 0.42) + ' L ' + (-dir * 0.6) + ' ' + (-r + hd * 0.42) + ' Z');
        head.setAttribute('fill', '#87f516'); head.setAttribute('stroke', '#87f516'); head.setAttribute('stroke-width', '1');
        head.style.fill = '#87f516';
        g.appendChild(head);
      } else {
        var c = 4;
        path.setAttribute('d', 'M ' + (-c - 3) + ' ' + (-c) + ' L ' + (-3) + ' 0 L ' + (-c - 3) + ' ' + c + ' M ' + (c + 3) + ' ' + (-c) + ' L 3 0 L ' + (c + 3) + ' ' + c);
      }
      path.setAttribute('stroke', '#87f516'); path.setAttribute('stroke-width', j.t === 't' ? '2.6' : '2.2');
      g.appendChild(path); g.setAttribute('class', 'fmd-ov'); svg.appendChild(g);
    }
    // part labels with leader lines; collisions pushed to a second row (or down the column on a phone)
    var maxH = 0; ch.forEach(function(k){ maxH = Math.max(maxH, L.pos[k].h); });
    var placed = [];
    ch.forEach(function(k){
      var p = L.pos[k], t = document.createElement('span');
      t.className = 'fmd-l' + (k === 'critterL' || k === 'critterR' ? ' fmd-l--light' : '');
      t.textContent = LBL[k];
      if (k === 'critterL') { var sm = document.createElement('small'); sm.textContent = 'The light engine'; t.appendChild(sm); }
      labels.appendChild(t);
      placed.push({ k: k, t: t, p: p });
    });
    if (!vert) {
      var rows = [-1e9, -1e9, -1e9, -1e9];
      placed.forEach(function(o){
        var w = o.t.offsetWidth, x0 = Math.max(0, Math.min(L.W - w, o.p.c - w / 2)), r = 0;
        while (r < 3 && x0 < rows[r] + 14) r++;
        rows[r] = x0 + w;
        var y = L.axis + maxH / 2 + 26 + r * 30;
        o.t.style.left = Math.round(x0) + 'px'; o.t.style.top = Math.round(y) + 'px';
        line(o.p.c, L.axis + o.p.h / 2 + 6, o.p.c, y - 7);
      });
    } else {
      var lx = L.axis + maxH / 2 + 34, last = -1e9;
      placed.forEach(function(o){
        var h = o.t.offsetHeight, y0 = Math.max(o.p.c - h / 2, last + 8);
        last = y0 + h;
        o.t.style.left = Math.round(lx) + 'px'; o.t.style.top = Math.round(y0) + 'px';
        var ly = y0 + Math.min(h, 13) / 2;
        line(L.axis + o.p.h / 2 + 6, o.p.c, lx - 8, ly);
      });
    }
    function line(x1, y1, x2, y2){
      var l = document.createElementNS(NS, 'path');
      l.setAttribute('d', 'M ' + x1 + ' ' + y1 + ' L ' + x2 + ' ' + y2);
      l.setAttribute('stroke', 'rgba(255,255,255,.35)'); l.setAttribute('stroke-width', '1');
      l.setAttribute('class', 'fmd-ov'); svg.appendChild(l);
    }
  }

  // morph (2026-10-08) = one put-together build straight into the next: the parts that go leave first, then the rest
  // seat from the Critter outward, new parts gliding in from well outside so the change reads at a glance
  var lastL = null;
  function render(bk, isOpen, instant, morph){
    if (instant) root.classList.add('no-tr');
    var L = layout(bk, isOpen), b = B[bk], prev = lastL; lastL = L;
    if (!prev) morph = false;
    var ci = L.chain.indexOf('critterL'), far = 0, dl = {}, W0 = morph ? 260 : 0, ST = morph ? 110 : 80;
    L.chain.forEach(function(k, n){ far = Math.max(far, Math.abs(n - ci)); });
    // parts that stay move together as one piece (staggered, the Critter slid over its own end cap); new ones then seat outward
    L.chain.forEach(function(k, n){ var d = Math.abs(n - ci); dl[k] = instant ? 0 : (isOpen ? (far - d) * 55 : W0 + (morph && prev.pos[k] ? 0 : d * ST)); });
    var maxDl = 0; Object.keys(dl).forEach(function(k){ maxDl = Math.max(maxDl, dl[k]); });
    // true when a part further out on the same side is in the other layout too, i.e. this one sits between parts that stay
    function boxed(ch, n, c, other){ return ch.some(function(o, m){ return (n < c ? m < n : m > n) && !!other.pos[o]; }); }
    Object.keys(el).forEach(function(k){
      var p = L.pos[k], e = el[k];
      if (p) {
        if (!e.classList.contains('is-in') && !instant) {
          var n = L.chain.indexOf(k), side = n < ci ? -1 : 1, from = { c: p.c + side * (morph ? 110 : 34) * L.s, w: p.w, h: p.h, a: p.a };
          // the handle between the Critter and the end cap cannot slide in along the axis, so it drops in from above
          if (morph && boxed(L.chain, n, ci, prev)) from = { c: p.c, w: p.w, h: p.h, a: p.a - 70 };
          e.style.transition = 'none'; place(k, from, L.vert, b.z[k] || 1); void e.offsetWidth; e.style.transition = '';
        }
        e.style.transitionDuration = '';
        e.style.transitionDelay = dl[k] + 'ms';
        place(k, p, L.vert, b.z[k] || 1);
        e.classList.add('is-in');
      } else {
        if (morph && prev.pos[k] && e.classList.contains('is-in')) {
          // leaving: slides off outward as it fades, or lifts away if it sat between parts that stay
          var q = prev.pos[k], pn = prev.chain.indexOf(k), pc = prev.chain.indexOf('critterL');
          var to = boxed(prev.chain, pn, pc, L) ? { c: q.c, w: q.w, h: q.h, a: q.a - 70 } : { c: q.c + (pn < pc ? -1 : 1) * 90 * prev.s, w: q.w, h: q.h, a: q.a }, z = B[prev.bk].z[k] || 1;
          e.style.transitionDuration = '.5s'; place(k, to, prev.vert, z);
          // its glow goes with it (the staff's tube glow hung in place while the tube slid off)
          if (gl[k]) { gl[k].style.transitionDuration = '.5s'; place(k, to, prev.vert, z, gl[k]); }
          if (hl[k]) { hl[k].style.transitionDuration = '.5s'; place(k, to, prev.vert, z + 1, hl[k]); }
        }
        e.style.transitionDelay = '0ms'; e.classList.remove('is-in');
      }
    });
    Object.keys(gl).concat(Object.keys(hl)).forEach(function(k){ var d = (dl[k] || 0) + 'ms'; if (gl[k]) gl[k].style.transitionDelay = d; if (hl[k]) hl[k].style.transitionDelay = d; });
    GL.forEach(function(k){
      var p = L.pos[k];
      if (p) { gl[k].style.transitionDuration = ''; place(k, p, L.vert, b.z[k] || 1, gl[k]); gl[k].classList.add('is-in'); } else gl[k].classList.remove('is-in');
    });
    Object.keys(hl).forEach(function(k){
      var p = L.pos[k];
      if (p) { hl[k].style.transitionDuration = ''; place(k, p, L.vert, (b.z[k] || 1) + 1, hl[k]); hl[k].classList.add('is-in'); } else hl[k].classList.remove('is-in');
    });
    // the flashlight alone: a soft RGB rainbow out of the front lens, to Joel's reference
    var cr = L.pos.critterL;
    place('beam', { c: cr.c - cr.w / 2 - cr.w * 0.65 + 1, w: cr.w * 1.3, h: cr.h * 5.2, a: cr.a }, L.vert, 1, beam);
    var bd = (dl.critterL || 0) + 'ms'; beam.style.transitionDelay = [bd, bd, bd, bd, '0s'].join(',');
    beam.classList.toggle('is-in', bk === 'light');
    root.style.setProperty('--fmd-hue', HUE[bk] || '0s');
    // the bracket sits under the first Critter (desktop only)
    var c = L.pos.critterL;
    badge.style.transitionDelay = morph ? [W0 + 'ms', W0 + 'ms', W0 + 'ms', '0s'].join(',') : '';
    if (L.vert) { badge.style.opacity = '0'; }
    else { badge.style.opacity = '1'; badge.style.width = c.w + 'px'; badge.style.left = (c.c - c.w / 2) + 'px'; badge.style.top = (c.a + c.h / 2 + 10) + 'px'; }
    scaleBar.style.width = (50 * L.s) + 'px';
    root.classList.toggle('is-open', isOpen);
    root.classList.remove('is-settled'); root.classList.remove('is-lit');
    // labels and joint marks are drawn for the EXPLODED layout and fade in once the parts land
    if (isOpen) overlays(L);
    clearTimeout(settleT);
    if (instant) { root.classList.add('is-settled'); if (!isOpen) root.classList.add('is-lit'); void root.offsetWidth; root.classList.remove('no-tr'); }
    else settleT = setTimeout(function(){ root.classList.add('is-settled'); if (!isOpen) root.classList.add('is-lit'); }, 700 + maxDl);
    tog.querySelector('span').textContent = isOpen ? 'Put it together' : 'Take it apart';
    tog.setAttribute('aria-pressed', isOpen ? 'true' : 'false');
    return instant ? 0 : 700 + maxDl;
  }

  function setBuild(bk, isOpen, instant, morph){
    cur = bk; open = isOpen;
    chips.forEach(function(c){ var on = c.getAttribute('data-b') === bk; c.classList.toggle('is-on', on); c.setAttribute('aria-selected', on ? 'true' : 'false'); c.tabIndex = on ? 0 : -1; });
    [].forEach.call(root.querySelectorAll('.fmd-buy__p'), function(p){ p.classList.toggle('is-on', p.getAttribute('data-p') === bk); });
    return render(bk, isOpen, instant, morph);
  }

  function clear(){ timers.forEach(clearTimeout); timers = []; }
  function later(fn, ms){ timers.push(setTimeout(fn, ms)); }
  // 2026-10-08 Joel: "start out by showing the rgb critter assembled ... and transition in to the next product soon after
  // so its an obvious animation". It opens put together and lit; once the stage is on screen, every few seconds the build
  // grows straight into the next one around the Critter. Tapping a chip or Take it apart still shows the parts.
  function nextOf(bk){ return ORDER[(ORDER.indexOf(bk) + 1) % ORDER.length]; }
  function step(wait){ later(function(){ if (!auto) return; var t = setBuild(nextOf(cur), false, false, !open); step(t + 2600); }, wait); }
  function restartBar(){ root.classList.remove('is-auto'); void root.offsetWidth; if (auto) root.classList.add('is-auto'); }
  function startAuto(){ if (stopped || reduce || auto || root.hasAttribute('data-static')) return; auto = true; restartBar(); step(1400); }
  function pauseAuto(){ auto = false; clear(); root.classList.remove('is-auto'); }
  function stopAuto(){ stopped = true; pauseAuto(); }

  chips.forEach(function(c){
    c.addEventListener('click', function(){
      stopAuto(); setBuild(c.getAttribute('data-b'), true);
      later(function(){ open = false; render(cur, false); }, 1500);
    });
    c.addEventListener('keydown', function(e){
      var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      if (!d) return; e.preventDefault(); stopAuto();
      var n = ORDER[(ORDER.indexOf(cur) + d + ORDER.length) % ORDER.length]; setBuild(n, true); chips[ORDER.indexOf(n)].focus();
    });
  });
  tog.addEventListener('click', function(){ stopAuto(); clear(); open = !open; render(cur, open); });
  var rt; window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(function(){ render(cur, open, true); }, 120); });

  // opens on its build put together and lit; the motion waits until the stage itself is half on screen, so the first change is seen
  var st = root.getAttribute('data-start'); setBuild(ORDER.indexOf(st) > -1 ? st : 'light', false, true);
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting && e.intersectionRatio >= 0.45) startAuto(); else pauseAuto(); }); }, { threshold: [0, 0.5] }).observe(stage);
  } else startAuto();
  root.fmSet = function(bk, isOpen){ stopAuto(); setBuild(bk, isOpen, true); };
})();
